module.exports = __webpack_public_path__ + "static/media/speak.ffccefe4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/speak.svg
// module id = 1262
// module chunks = 21